export const sr = {
    common: {
        PIN_CODE_LABEL: 'Pin kod',
        USER_NAME_LABEL: 'Puno ime',
        comment: 'Komentar',
        year: 'Godina',
        configuration: 'Konfiguracija',
        cancel: 'Otkaži',
        search: 'Pretraga',
        remove: 'Ukloni',
        confirmationDialogTitle:
            'Da li ste sigurni da želite da uklonite ovaj predmet?',
        selectDate: 'Izaberite datum',
        select: 'Izaberite',
        notFound: 'Nije pronađeno',
        equipmentPickerPlaceholder: 'Objekat opreme...',
        searchPlaceholder: 'Pretraži...',
        equipmentTypePickerPlaceholder: 'Tip opreme...',
        equipmentTypePickerTitle: 'Izaberite tip opreme',
        emptyTableMessage: 'Nema podataka',
        flowPikcerTitle: 'Izaberite protok',
        selectIcon: 'Izaberite ikonicu',
        locationPickerTitle: 'Izaberite lokaciju',
        locationPlaceholder: 'Lokacija...',
        noSublocations: 'Nema podlokacija',
        locationsTitle: 'Lokacije',
        edit: 'Uredi',
        save: 'Sačuvaj',
        added: 'Dodato',
        updated: 'Ažurirano',
        add: 'Dodaj',
        removed: 'Uklonjeno',
        reload: 'Ponovo učitaj',
        confirm: 'Potvrdi',
        rollBack: 'Vrati',
        images: 'Slike',
        documents: 'Dokumenti',
        download: 'Preuzmi',
        saved: 'Sačuvano',
        date: 'Datum',
        hour: 'Sat',
        preview: 'Pregled',
        data: 'Podaci',
        attributes: 'Atributi',
        checkList: 'Lista za proveru',
        name: 'Ime',
        type: 'Tip',
        status: 'Status',
        designation: 'Oznaka',
        symbol: 'Simbol',
        serialNumber: 'Serijski broj',
        registryNumber: 'Registarski broj',
        machineNumber: 'Broj mašine',
        udtNumber: 'UDT broj',
        manufacturedYear: 'Godina proizvodnje',
        manufacturer: 'Proizvođač',
        supplier: 'Dobavljač',
        mainSupplier: 'Glavni dobavljač',
        attribute: 'Atribut',
        nameRequired: 'Ime je obavezno',
        yearGreaterThan: 'Godina mora biti veća od',
        location: 'Lokacija',
        fieldRequired: 'Ovo polje je obavezno',
        description: 'Opis',
        minimumQuantity: 'Minimalna količina',
        optimalQuantity: 'Optimalna količina',
        priority: 'Prioritet',
        formatYYYY: 'Format YYYY',
        storageQuantity: 'Količina u skladištu',
        quantity: 'Količina',
        quantityGreaterThan: 'Količina mora biti veća od',
        machine: 'Mašina',
        tool: 'Alat',
        order: 'Narudžbina',
        required: 'Obavezno',
        dateFormat: 'Format datuma',
        selectDictionary: 'Odaberite rečnik',
        selectDictionaryValue: 'izaberite vrednost rečnika',
        return: 'Vrati',
        parameters: 'Parametri',
        editCategory: 'Izmeni kategoriju',
        addCategory: 'Dodaj novu kategoriju',
        changeColor: 'Promeni boju',
        noColor: 'Bez boje',
        shift: 'Smena',
        start: 'Početak',
        end: 'Kraj',
        shiftSchema: 'Šema smene',
        shifts: 'Smena',
        dictionary: 'Rečnik',
        subEntries: 'Podstavke',
        key: 'Ključ',
        value: 'Vrednost',
        moveUp: 'Pomeri gore',
        moveDown: 'Pomeri dole',
        addLocation: 'Dodaj novu lokaciju',
        editLocation: 'Izmeni lokaciju',
        companiesDatabase: 'Baza podataka kompanija',
        flows: 'Tokovi',
        read: 'Čitaj',
        write: 'Piši',
        noImage: 'Nema slike',
        email: 'E-pošta',
        function: 'Funkcija',
        active: 'Aktivno',
        notActive: 'Nije aktivirano',
        disabled: 'Onemogućeno',
        entryNumber: 'Broj stavke',
        issuedDate: 'Datum izdavanja',
        expiresDate: 'Datum isteka',
        move: 'Pomeri',
        separateForm: 'Odvoji od',
        separate: 'Odvojiti',
        warehouse: 'Skladište',
        actions: 'Akcije',
        putInCurrentLocation: 'Stavite u trenutnu lokaciju',
        selectLocationFormRightMenu:
            'Odaberite lokaciju iz menija s desne strane',
        showUnassignedItems: 'Prikaži nepridružene stavke',
        separated: 'Odvojeno',
        moved: 'Pomereno',
        categories: 'Kategorije',
        welcome: 'Dobrodošli',
        loginToSignaloCMMS: 'Prijavite se na Signalo CMMS',
        login: 'Prijava',
        loginByEmailAndPassword: 'Prijava putem e-pošte i lozinke',
        loginByCode: 'Prijavite se putem koda',
        accessCode: 'Kod za pristup',
        enterEmail: 'Unesite e-poštu',
        enterPassword: 'Unesite lozinku',
        enterCode: 'Unesite kod',
        userNotFound: 'Korisnik nije pronađen',
        userNotActivated: 'Korisnik nije aktiviran',
        userDisabled: 'Korisnik je onemogućen',
        wrongPassword: 'Pogrešna lozinka',
        locations: 'Lokacije',
        pageNotFound: 'Stranica nije pronađena',
        group: 'Grupa',
        yes: 'Da',
        no: 'Ne',
        hourlyCost: 'Satišnji trošak',
        price: 'Cena',
        newEntry: 'Nova stavka',
        predictedFinishTime: 'Predviđeno vreme završetka',
        ok: 'U redu',
        archive: 'Arhiva',
        costs: 'Troškovi',
        companyManagement: 'Upravljanje kompanijom',
        companyData: 'Podaci o kompaniji',
        supportedLanguages: 'Podržani jezici',
        en: 'Engleski',
        pl: 'Poljski',
        es: 'Španski',
        de: 'Nemački',
        it: 'Italijanski',
        fr: 'Francuski',
        ru: 'Ruski',
        uk: 'Ukrajinski',
        pt: 'Portugalski',
        tr: 'Turski',
        nl: 'Holandski',
        sr: 'Srpski',
        defaultLanguage: 'Podrazumevani jezik',
        companyLogo: 'Logo kompanije',
        notificationsManagement: 'Upravljanje obaveštenjima',
        category: 'Kategorija',
        today: 'Danas',
        month: 'Mesec',
        week: 'Nedelja',
        day: 'Dan',
        close: 'Zatvori',
        show: 'Prikaži',
        rollBackFormalConfirmation: 'Potvrda formalnog vraćanja',
        signUp: 'Registruj se',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Oznaka za puno ime',
        userNameSurname: 'Puno ime',
        userSurnameName: 'Prezime i ime',
        phone: 'Broj telefona',
        password: 'Lozinka',
        password_confirmation: 'Potvrdi lozinku',
        unassignedItems: 'Nepridružene stavke',
        currency: 'Valuta',
        general: 'Opšte',
        timezone: 'Vremenska zona',
        users: 'Korisnici',
        groups: 'Grupe',
        productionLine: 'Linija za proizvodnju',
        part: 'Deo',
        fittingParts: 'Pribori',
        workSchema: 'Šema rada',
        workSchemas: 'Šeme rada',
        holiday: 'Praznik',
        changePassword: 'Promeni lozinku',
        showRest: 'Prikaži ostalo',
        pageNotPermitted: 'Stranica nije dozvoljena',
        waitingForActivation: 'Čeka se aktivacija',
        editGroup: 'Izmeni grupu',
        addGroup: 'Dodaj grupu',
        reportProblem: 'Prijavi problem',
        describeOccuredIssue: 'Opisite nastali problem',
        markAllAsRead: 'Označi sve kao pročitano',
        unitType: 'Tip jedinice',
        unit: 'Jedinica',
        unitPrice: 'Jedinična cena',
        notConfigured: 'Nije konfigurisano',
        rowsPerPage: 'Redova po stranici',
        rowsOfPage: 'od',
        true: 'Tačno',
        false: 'Netačno',
        export: 'Izvoz',
        chooseFileFormat: 'Odaberite format datoteke',
        exported: 'Izvezeno',
        terminals: 'Terminali',
        terminal: 'Terminal',
        selectEquipment: 'Odaberite opremu',
        futureIssues: 'Budući problemi',
        scheduledOn: 'Zakazano za',
        planned: 'Planirano',
        notPlanned: 'Nenajavljeno',
        showOpenIssues: 'Prikaži otvorene probleme',
        pin: 'PIN',
        assignedEquipment: 'Dodeljena oprema',
        terminalEquipment: 'Terminal oprema',
        detach: 'Odvojiti',
        attach: 'Prikvačiti',
        dashboardConfig: 'Konfiguracija kontrolne table',
        addColumn: 'Dodaj kolonu',
        addRow: 'Dodaj red',
        removeRow: 'Ukloni red',
        registerTerminal: 'Registruj terminal',
        issueGeneratesCost: 'Vreme neefikasnosti generiše troškove',
        selectColor: 'Odaberite boju',
        belowMinimum: 'Ispod minimuma',
        belowOptimum: 'Ispod optimalnog',
        synchronization: 'Sinhronizacija',
        synchronizationExport: 'Izvoz rezervnih delova',
        synchronizationImport: 'Uvoz rezervnih delova',
        mapping: 'Mapiranje',
        returnTo: 'Vrati se na',
        jobStatusses: 'Procesi',
        hidden: 'Skriveno',
        editEvent: 'Izmeni događaj',
        threeDays: '3 dana',
        addEvent: 'Dodaj događaj',
        plannedIssues: 'Planirani problemi',
        currentService: 'Trenutna usluga',
        searchLocation: 'Pronađi lokaciju',
        all: 'Sve',
        unfinished: 'Nedovršeno',
        numberOfIssues: 'Broj problema',
        unknown: 'Nepoznato',
        partEntry: 'Deo (stavka)',
        foundItems: 'Pronađene stavke',
        output: 'Izlaz',
        copied: 'Kopirano',
        link: 'Veza',
        authorizationRequired: 'Potrebna autorizacija',
        authorizationRequiredDescriptionUser:
            'Nažalost, nemate dovoljnu autorizaciju {value}. Zatražite od ovlašćene osobe da odobri radnju.',
        authorizationRequiredDescriptionTerminal:
            'Koristite svoj kod za pristup da biste autorizovali radnju.',
        showAll: 'Prikaži sve',
        showClassicView: 'Klasični prikaz',
        noIssuesInCategory: 'Nema problema u ovoj kategoriji.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Broj problema u ovoj kategoriji i podkategorijama.',
        numberOfIssuesInThisCategory: 'Broj problema u ovoj kategoriji.',
        minBarcodeLength: 'Minimalna dužina barkoda',
        currentPage: 'Trenutna stranica',
        allPages: 'Sve stranice',
        selectFormat: 'Odaberite format',
        provided_currency: 'Pružena valuta',
        provided_quantity: 'Pružena količina',
        provided_unit: 'Pružena jedinica',
        provided_unit_price: 'Pružena cena po jedinici',
        unit_price: 'Cena po jedinici',
        quantity_available: 'Dostupna količina',
        editBarcode: 'Izmeni barkod',
        crews: 'Ekipe',
        scheduleEventTypes: 'Tipovi planiranih događaja',
        crew: 'Ekipa',
        scheduleEvent: 'Planirani događaj',
        available: 'Dostupno',
        'App\\Models\\Crew': 'Ekipa',
        'App\\Models\\User': 'Korisnik',
        'App\\Models\\Equipment': 'Oprema',
        'App\\Models\\Part': 'Part',
        Crew: 'Ekipa',
        User: 'Korisnik',
        Equipment: 'Oprema',
        Part: 'Part',
        scheduleEvents: 'Planirani događaji',
        event: 'Događaj',
        externalSystems: 'Spoljni sistemi',
        user: 'Korisnik',
        availability: 'Dostupnost',
        inheritColorFromParentIfCustomNotSet:
            'Nasledi boju od roditelja ako nije prilagođena',
        pickFromAllParts: 'Izaberi iz svih delova',
        takeTool: 'Uzmi alat',
        returnTool: 'Vrati alat',
        personWhoTake: 'Osoba koja uzima',
        personWhoReturn: 'Osoba koja vraća',
        takenAt: 'Uzeto u',
        takenBy: 'Uzeto od',
        toolIssuedBy: 'Alat izdat od',
        commentTake: 'Komentar uzimanja',
        commentReturn: 'Komentar vraćanja',
        change: 'Promeni',
        onlyWithActiveRMIssues: 'Samo sa aktivnim RM zahtevima',
        externalSystem: 'Spoljni sistem',
        rejectIssue: 'Odbaci problem',
        withdrawIssueRejection: 'Povuci odbijanje problema',
        rejectionReason: 'Razlog odbijanja',
        rejected: 'Odbijeno',
        showCrewMembers: 'Prikaži članove ekipe',
        crewMembers: 'Članovi ekipe',
        helpGroup: 'Usluga',
        partsTakenByUser: 'Delovi uzeti od strane korisnika',
        pickParts: 'Izdaj delove',
        selectPersonWhoTakes: 'Odaberi osobu koja uzima',
        changePersonWhoTakes: 'Promeni osobu koja uzima',
        quantityToPick: 'Količina za izdavanje',
        pickLocation: 'Lokacija preuzimanja',
        selectPartsToPick: 'Izaberite delove za preuzimanje',
        partSelected: 'Izabrani deo',
        scanCodeOr: 'Skenirajte šifru ili',
        returnPart: 'Vrati deo',
        myTakenParts: 'Delovi koje sam preuzeo',
        takenFromLocation: 'Preuzeto sa lokacije',
        takenQuantity: 'Preuzeta količina',
        providedUnit: 'Ponuđena jedinica',
        providedQuantity: 'Ponuđena količina',
        selectFromStorage: 'Izaberite iz skladišta',
        selectFromMyPickedParts: 'Izaberite iz preuzetih delova',
        exportProcessInProgressMessage:
            'Proces izvoza podataka je upravo počeo, kada se završi, videt ćete odgovarajuću obaveštenje sa linkom do fajla.',
        yourDocumentIsReady: 'Vaš dokument je spreman',
        rotateScreen: 'Rotiraj ekran',
        addRule: 'Dodaj pravilo',
        editRule: 'Izmeni pravilo',
        summary: 'Sažetak',
        onlyAvailableEmployees: 'Prikaži samo dostupne zaposlene',
        calculated_unit_price: 'Preračunata jedinična cena',
        calculated_quantity: 'Preračunati iznos',
        next: 'Sledeći',
        maintenanceMode: 'Režim održavanja',
        applicationMayBeUnavailableForFewMinutes:
            'Aplikacija može biti nedostupna nekoliko minuta',
        appWillRefreshIn: 'Aplikacija će se ponovo učitati',
        landscape: 'Pejzaž',
        portrait: 'Portret',
        orientation: 'Orijentacija',
        format: 'Format',
        service: 'Služba',
        leader: 'Brigadisti',
        defaultView: 'Podrazumevani prikaz',
        view: 'Pogled',
        oneDay: '1 dana',
        object: 'Objekat',
        finished: 'Gotov',
        onlyNotFinished: 'Samo što nije završeno',
        generate: 'Generiši',
        error: 'Greška',
        cell: 'Ćelija',
        resolutionSummary: 'Kraj rezimea',
        rejected_at: 'Datum odbijanja',
        rejected_by: 'Odbijeno od',
        finishedByUser: 'Završen',
        formalConfirmByUser: 'Formalna potvrda od',
        formalConfirmAt: 'Datum zvanične potvrde',
        valueDeleted: '[Vrednost je obrisana]',
        hasNotPlannedIssue: 'Nije planirao probleme',
        showInStorage: 'Prikaži u skladištu',
        changeCode: 'Promenite kod',
        staffProfiles: 'Profili zaposlenih',
        profile: 'Profil',
        user_bug: 'Greška u aplikaciji',
        user_kaizen: 'Predlog promene',
        changeSuggestions: 'Promenite predloge',
        showOnlyCurrentlyAvailable: 'Prikaži samo trenutno dostupno',
        resetPassword: 'Podseti lozinku',
        forgotPassword: 'Zaboravili ste lozinku',
        resetPasswordMailSent:
            'Poslali smo vezu za postavljanje nove lozinke na navedenu adresu e-pošte',
        manyEventsThisTime: 'Mnogo događaja u ovo vreme',
        importScheduleCheckboxLabel:
            'Izbrišite zakazane događaje u izabranom mesecu za zaposlene navedene u datoteci',
        inheritedEvent: 'Nasleđeni događaj',
        inheritedModifiedEvent: 'Izmenjeni nasleđeni događaj',
        equipmentId: 'ID opreme',
        entryId: 'Entri ID',
        partId: 'Part ID',
        suggestionsEmail: 'Imejl na koji će se slati predlozi za promene',
        meters: 'Brojači',
        scanCardToAuth: 'Skenirajte karticu za autorizaciju',
        scanCard: 'Skenirajte karticu',
        cart: 'Kutija za razmenu',
        emptyCardMessage:
            'Počnite da skenirate proizvode ili ih izaberite sa liste da biste ih dodali u korpu.',
        terminalMode: 'Terminalni režim',
        askPermittedUserToConfirmPartsExchange:
            'Pitajte dozvoljenog korisnika da potvrdi zamenu delova',
        partsIssued: 'Delovi izdati',
        areYouSureAboutCancel: 'Da li ste sigurni da želite da otkažete?',
        areYouSureAboutRemoveFromCart:
            'Da li ste sigurni da želite da uklonite iz korpe?',
        standard: 'Standard',
        idNumber: 'Broj identifikacije',
        takeParts: 'Preuzmi delove',
        returnParts: 'Vrati delove',
        quantityToReturn: 'Količina za vraćanje',
        partsPendingApproval: 'Delovi na čekanju odobrenja',
        partsReturned: 'Delovi vraćeni',
        partsAddedToPendingApproval: 'Delovi dodati na čekanje odobrenja',
        approvePartsReturn: 'Odobri vraćanje delova',
        partReturnApproved: 'Vraćanje delova odobreno',
        partUsage: 'Upotreba delova',
        awaitsReturn: 'Čeka se povratak',
        entrySelection: 'Selekcija unosa',
        correctQuantity: 'Ispravite količinu',
        quantityCorrection: 'Korekcija količine',
        entrySelectionAsc: 'Selekcija unosa (rastuće)',
        entrySelectionDesc: 'Selekcija unosa (opadajuće)',
        metersSettings: 'Podešavanja brojača',
        countableFields: 'Brojiva polja',
        equipmentTypes: 'Tipovi opreme',
        fieldName: 'Ime polja',
        countableField: 'Brojivo polje',
        partsStatusTaken: 'Preuzeto',
        rejectPartsReturn: 'Odbij vraćanje delova',
        areYouSureAboutRejectPartsReturn:
            'Da li ste sigurni da želite da odbijete vraćanje delova?',
        partReturnRejected: 'Vraćanje delova odbijeno',
        counterFields: 'Polja brojača',
        counterName: 'Ime brojača',
        counterFieldName: 'Ime polja brojača',
        counterId: 'ID brojača',
        counterUUID: 'UUID brojača',
        counterPickerPlaceholder: 'Odaberite brojač',
        pickFromPartsList: 'Izaberite iz liste delova',
        changeLocation: 'Promenite lokaciju',
        isPartStorageRoot: 'Korijensko skladište delova',
        isStorageRoot: 'Korijensko skladište delova',
        areYouSureAboutArchiveIssue:
            'Da li ste sigurni da želite da arhivirate izdavanje?',
        ganttChart: 'Gantogram',
        table: 'Tabela',
        fittingEquipment: 'Oprema za montažu',
        notAssigned: 'Nije dodeljeno',
        counters: 'Brojači',
        machineHourlyCostNotProvided: 'Cena mašine po satu nije navedena',
        eventTypesMightBeDefinedHere:
            'Tipovi događaja mogu biti definisani ovde',
        toolsTakenByUser: 'Alati uzeti od strane korisnika',
        predictedReturnDate: 'Predviđeni datum povratka',
        estimatedTimeOfUsingToolInHours:
            'Procenjeno vreme korišćenja alata (u satima)',
        showOnlyAvailable: 'Prikaži samo dostupno',
        toolTakeLog: 'Dnevnik uzimanja alata',
        takeDate: 'Datum uzimanja',
        returnDate: 'Datum povratka',
        personWhoAcceptReturn: 'Osoba koja prihvata povrat',
        statisticStrategy: 'Strategija pristupačnosti',
        EquipmentPlannedStrategy: 'Prema planu rada',
        EquipmentConstantAvailabilityStrategy: 'Uvek na raspolaganju',
        actionAfterIssueFinish: 'Akcija nakon završetka izdavanja',
        enabled: 'Omogućeno',
        categoryOfNewIssue: 'Kategorija novog izdavanja',
        workNotStarted: 'Rad nije započet',
        colorInherited: 'Nasleđena boja',
        abcClassification: 'ABC klasifikacija',
        xyzClassification: 'XYZ klasifikacija',
        classification: 'Klasifikacija',
        filters: 'Filteri',
        wipeFilters: 'Obriši filtere',
        takePartsFromUser: 'Uzmi delove od korisnika',
        selectPersonWhoReturns: 'Izaberite osobu koja vraća delove',
        changePersonWhoReturns: 'Promenite osobu koja vraća delove',
        returnLocation: 'Lokacija povratka',
        returnQuantity: 'Količina povratka',
        globalSettings: 'Globalna podešavanja',
        delimiter: 'Delimiter',
        fieldRules: 'Pravila polja',
        fieldValue: 'Vrednost polja',
        user_email_regex: 'E-mail korisnika',
        barcodeLength: 'Dužina barkoda',
        partLine: 'Linija delova',
        partFamily: 'Porodica delova',
        partBatch: 'Serija delova (batch)',
        testValueValid: 'Вредност теста је важећа',
        testValueNotValid: 'Вредност теста није важећа',
        canBePicked: 'Može se birati',
        issue_criticality: 'Pitanja – kritičnost',
        issue_help_webapp: 'Problemi – potrebna je podrška (aplikacija)',
        issue_help_terminal: 'Problemi – potrebna je podrška (Terminal)',
        issue_kind: 'Tip prijave',
        HIDE: 'Sakriti',
        SHOW: 'Prikaži',
        REQUIRE: 'Zahtevaju',
        propagateValues: 'Propagacija vrednosti',
        archived: 'arhivirano',
        singleEvent: 'Jedan ulazak',
        seriesOfEvents: 'Serija unosa',
        omitWeekends: 'Izbegavajte vikende',
        allEntriesSaved: 'Svi unosi su dodati',
        parentCategory: 'Roditelj Kategorija',
        first_day_of_week: 'Prvi dan u nedelji',
        assignEmployee: 'Odredite zaposlenog',
        addNewMachine: 'Dodajte novu mašinu',
        addNewTool: 'Dodajte novi alat',
        parentLocation: 'Lokacija roditelja',
        equipmentStates: 'Stanja opreme',
        equipmentState: 'Stanje opreme',
        fontColor: 'Boja fonta',
        downtime: 'Zastoji',
        setState: 'Podesite stanje',
        from: 'iz',
        to: 'do',
        inProgress: 'u toku',
        noEntries: 'nema unosa',
        products: 'proizvodi',
        product: 'proizvod',
        setCurrentProduct: 'Podesite proizvod koji je trenutno u proizvodnji',
        commentable: 'Mogućnost komentarisanja',
        allows_state_update: 'Potrebna je promena stanja tokom komentara',
        undescribed: 'neopisivo',
        state: 'Stanje',
        productionMonitor: 'Monitor proizvodnje',
        undescribedStates: 'Neopisana stanja',
        toolsPicker: 'Uzmi / vrati alat',
        toolsGroups: 'Grupe alata',
        of: 'of',
        image: 'Photo',
        selectTools: 'Izaberite alate',
        takeTools: 'Preuzmite alate',
        returnTools: 'Vratite alat',
        askPermittedUserToConfirmToolsExchange:
            'Zamolite ovlašćeno lice da potvrdi izdavanje/vraćanje alata skeniranjem kartice ili unošenjem koda.',
        toolsPendingApproval: 'Vraćeni alati čekaju odobrenje',
        production_monitor_visible_columns:
            'Monitor proizvodnje - vidljive kolone',
        details: 'Detalji',
        otherData: 'Ostali podaci',
        showAllTools: 'Prikaži sve alate',
        allTools: 'Svi alati',
        approveToolReturn: 'Prihvatite vraćanje alata',
        rejectToolReturn: 'Odbijte vraćanje alata',
        areYouSureAboutRejectToolReturn:
            'Da li ste sigurni da želite da odbijete vraćanje alata?',
        areYouSureAboutAcceptToolReturn:
            'Da li ste sigurni da želite da potvrdite vraćanje alata?',
        toolReturnApproved: 'Povrat alata odobren',
        toolReturnRejected: 'Povrat alata je odbijen',
        toReturn: 'Povratiti',
        toolsCart: 'Kutija za razmenu - alati',
        toolsIssued: 'Preuzete alatke',
        toolsAddedToPendingApproval:
            'Alati su dodati na listu čekanja za odobrenje povratka',
        toolsReturned: 'Alati vraćeni',
        mainShift: 'Glavna smena',
        scanCode: 'Skenirajte kod',
        codeRecognized: 'Kod prepoznat',
        moveAllEntriesFromCurrentLocation: 'Premesti sve unose sa ove lokacije',
        newAwaitingValue: 'Nova vrednost čeka odobrenje',
        newValuesArePendingConfirmation: 'Promene čekaju odobrenje',
        changeRequests: 'Zahtevi za promenu',
        currentValues: 'Trenutne vrednosti',
        requestedValues: 'Vrednosti koje treba promeniti',
        removeRequestIsWaitingForApprove: 'Brisanje čeka odobrenje',
        imageRemoveRequestLabel: 'Brisanje fotografije',
        areYouSureAboutCancelChangeRequest:
            'Da li ste sigurni da želite da otkažete zahtev za promenu?',
        document: 'Dokument',
        rename: 'Preimenuj',
        openInEditor: 'Otvori u uređivaču',
        unsavedChangesMayBeLost: 'Nesačuvane promene mogu biti izgubljene',
        location_name_regex: 'Pravilo naziva lokacije',
        employeesWorkingCount: 'Broj zaposlenih koji rade na ovom pitanju',
        always: 'uvek',
        indexes: 'Indeksi',
        indexesEntriesTypes: 'Vrste unosa',
        indexEntry: 'Indek entri',
        index: 'Indeks',
        pickIndex: 'Izaberite indeks',
        report: 'Izveštaj',
        reportGenerationInProgress: 'Izveštaj se generiše',
        production_monitor_equipment_state_change:
            'Promena statusa mašine sa monitora proizvodnje',
        part_entries_auto_barcode_generation:
            'Automatsko generisanje bar kodova za unos delova',
        new_issue_equipment_kind: 'Vrsta opreme u novoj aplikaciji',
        manageVisibleColumns: 'Podesite vidljivost kolone',
        columnName: 'Naziv kolone',
        visible: 'Vidljivo',
        partStorageRootWarningMessage:
            'Ova lokacija će biti postavljena kao glavna lokacija skladišta delova, skladište i prozor za izbor lokacije skladišta će vam omogućiti samo da izaberete unose koji se nalaze na ovoj lokaciji',
        entriesLocation: 'lokacija unosa',
        cloneIssue: 'Klon',
        machinesMap: 'Mapa mašina',
        doYouWantToAddNewMarker: 'Da li želite da dodate novu oznaku ovde?',
        areYouSureAboutRemoveMarker:
            'Da li ste sigurni da želite da uklonite ovu oznaku?',
        plants: 'Fabrika postrojenja',
        plant: 'Fabrika',
        buildings: 'Zgrade',
        building: 'Zgrada',
        floors: 'Podovi',
        floor: 'Pod',
        map: 'Mapa',
        areYouSureAboutMoveMarker:
            'Da li ste sigurni da želite da premestite ovaj marker?',
        marker: 'Marker',
        addNewMarkerTooltipMessage:
            'Da biste dodali novi marker, kliknite desnim tasterom miša na mapu.',
        takenTools: 'Objavljeni alati',
        askPermittedUserToConfirmToolExchange:
            'Zamolite ovlašćeno lice da potvrdi izdavanje/vraćanje alata skeniranjem kartice ili unošenjem koda.',
        warnDays: 'Upozorenje pre isteka (dana)',
        licenseType: 'Tip licence',
        licenseGroup: 'Grupa licenci',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Zahtevati potvrdu / odbijanje po povratku preuzetih alata',
        attachments: 'Prilozi',
        attachment: 'Prilog',
        searchInCurrentLocation: 'Pretražite na svojoj trenutnoj lokaciji',
        icon: 'ikona',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'drugo',
        tags: 'Kartice / Tags',
        tag: 'Kartica / Tag',
        userPinCode: 'PIN korisnika kartice',
        pin_code_field_type: 'Tip PIN koda',
        alphanumeric: 'Alfanumerički',
        numeric: 'Numerički',
        showCodeOwnerNameDuringParing:
            'Prikažite ime vlasnika koda prilikom uparivanja sa karticom/oznakom',
        showUsernameInCart: 'Prikaži korisničko ime u korpi',
        flag: 'Zastava',
        flags: 'Zastave',
        manageFlags: 'Upravljajte zastavama',
        skills: 'Veštine',
        skill: 'Veština',
        skillRank: 'Ocena',
        selectToolsByType: 'Izaberite alate prema vrsti',
        openToolsPickerOnCartInit:
            'Automatski otvorite prozor za izbor alata kada odete u korpu.',
        toolsTypes: 'Vrste alata',
        workOrderTemplates: 'Šabloni radnih naloga',
        workOrderTemplate: 'Šablon radnog naloga',
        workOrders: 'Radnih naloga',
        workOrder: 'Radni nalog',
        employee: 'Zaposleni',
        workOrderCreatedBy: 'Naručila',
        print: 'Print',
        issueCreated: 'Karta je napravljena',
        newIssue: 'Novi izveštaj',
        sampleButtonPlaceholder: 'Dugme uzorka',
        preferences: 'Preferences',
        buttonsSize: 'Veličina dugmeta',
        defaultValue: 'Zadana vrijednost',
        warning: 'upozorenje',
        allowedIssuesCategories: 'Kategorije dozvoljenih pitanja',
        hideAbilityToAssignEmployeesToIssue:
            'Sakrijte mogućnost dodeljivanja zaposlenih problemu',
        issuesWithRelatedCategories: 'Uključite potkategorije',
        issuesLimit: 'Ograničenje pitanja',
        issuesLimits: 'Pitanja – granice',
        closeLocker: 'Zatvorite ormar',
        closeLockerMessage: 'Da nastavite, zatvorite kabinet',
        closedTooFast: 'Da li ste prebrzo zatvorili?',
        doYouWantToReopenLocker: 'Da li želite da ponovo otvorite ormarić?',
        reopen: 'Ponovo otvori',
        quit: 'Završi',
        hiddenFields: 'Skrivena polja',
        defaultValues: 'Default vrednosti',
        paddingBottom: 'Prazan prostor na dnu',
        allVisibleFieldsRequired: 'Zahtevajte da se popune sva vidljiva polja',
        emailConfirmation: 'Potvrda adrese e-pošte',
        user_active_after_email_confirm:
            'Korisnički nalog se automatski aktivira nakon potvrde vaše adrese e-pošte',
        phone_change_requires_confirmation_code:
            'Promena broja telefona zahteva potvrdu sa kodom',
        toolsLocation: 'Lokacija alata',
        manageFilters: 'Upravljajte filterima',
        erase: 'obrisati',
        can_pick_undescribed_equipment_state:
            "Vozmozhnost' vybrat' neopisuyemoye sostoyaniye",
        helpdesk: 'šalter za informacije',
        measureTypes: 'Vrste merenja',
        measureType: 'Vrsta merenja',
        measurable: 'Merljiv indikator',
        measurables: 'Merljivi indikatori',
        measurements: 'Measurement',
        measurement: 'Measurement',
        measuredAt: 'Datum merenja',
        employeeNumber: 'Broj radnika',
        lastLocation: 'Poslednja lokacija',
        readonly: 'Samo za čitanje',
        equipment: 'Oprema',
        conditions: 'Uslovi',
        permission: 'Dozvola',
        formula: 'Formula',
        notification: 'Notification',
        transition: 'Prelaz',
        fillValuesToChangeState:
            'Popunite vrednosti da biste promenili status.',
        loginTo: 'Prijavite se na',
        appName: 'Signalo CMMS',
        manageState: 'Upravljajte stanjem',
        webMessage: 'Veb poruka',
        terminalId: 'Terminal Id',
        operatorId: 'Operator Id',
        newConversation: 'Nova tema',
        application: 'Aplikacija',
        phones: 'Brojevi telefona',
        message: 'Poruka',
        channels: 'kanaly',
        url: 'URL',
        kind: 'Vrsta',
        forkfleetConfigId: 'Konfiguracija Forkfleet',
        create: 'Kreiraj',
        terminate: 'prekinuti',
        recreateIssue: 'Поново креирајте карту',
        ordinal: 'Redna vrednost',
        parameterName: 'Naziv parametra',
        backgroundColor: 'Boja pozadine',
        columns: 'Broj kolona',
        colspan: 'Širina (kolone)',
        fill: 'kompletan',
        duplicate: 'Duplikat',
        loginAsThisUser: 'Prijavite se kao ovaj korisnik',
        partLot: 'Series',
        minBrowserVersion: 'Potrebna je minimalna verzija pretraživača',
        currentVersion: 'Trenutna verzija',
        equipment_planned_completed_percent_target:
            'Ciljni procenat za sprovođenje planiranih inspekcija',
        autoTranslate: 'Automatski prevod',
        auto_translation: 'Automatski prevod',
        awaitingAutoTranslation: 'Čeka se automatski prevod',
        signaturePinTagConfirmationText1:
            'Potpišite se @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'ili skenirajte svoju karticu.',
        signedWithPinCode: 'Potpisano @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Potpisano karticom/tagom',
        trusted_device_code_login_users_limit:
            'Brza prijava - broj prikazanih korisnika',
        display_fields_issue_created_at: 'Prikaži polja - Kreiranje izveštaja',
        docs_sidebar_hidden_by_default:
            'Dokumenti - sakrij bočnu traku po defaultu',
        issue: 'Prijava',
        control: 'Kontrola',
        compatibility: 'Kompatibilnost',
        replacement: 'Zamena',
        backCompatibility: 'Dvosmerna kompatibilnost',
    },
    placeholders: {
        part: 'Odaberite deo...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Broj telefona...',
        password: 'Lozinka...',
        password_confirmation: 'Potvrdite lozinku...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'Nije vaš nalog?',
    },
    signup: {
        registered: 'Uspešno!',
        emailConfirmed: 'Imejl je potvrđen.',
        registered_info: 'Zamolite svog nadređenog da aktivira vaš nalog',
        confirmEmailAddress:
            'Vaš nalog je kreiran, kliknite na vezu u e-poruci da potvrdite svoju adresu.',
        tokenNotFoundError:
            'E-pošta je već potvrđena ili je veza za potvrdu nevažeća.',
    },
    paramTypes: {
        text: 'Tekst',
        note: 'Napomena',
        integer: 'Ceo broj',
        decimal: 'Decimalni broj',
        date: 'Datum',
        time: 'Sat',
        datetime: 'Datum i sat',
        color: 'Boja',
        icon: 'Ikona',
        boolean: 'Ne / Da',
        signature: 'potpis',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Ime',
        path: 'Putanja do datoteke',
        category: 'Kategorija',
        equipment: 'Oprema',
        criticality: 'Kritičnost',
        status: 'Status',
        created: 'Kreirano',
        createdBy: 'Kreirano od',
        fp: 'FP',
        type: 'Tip',
        designation: 'Oznaka',
        symbol: 'Simbol',
        serialNumber: 'Serijski broj',
        registryNumber: 'Registarski broj',
        udtNumber: 'UDT broj',
        manufacturedYear: 'Godina proizvodnje',
        actions: 'Akcije',
        title: 'Naslov',
        data: 'Datum',
        archived: 'Arhivirano',
        manufacturerSymbol: 'Simbol proizvođača',
        min: 'Min',
        opt: 'Opt',
        quantity: 'Količina',
        priority: 'Prioritet',
        price: 'Cena',
        kind: 'Vrsta',
        description: 'Opis',
        default: 'Podrazumevano',
        warning: 'Upozorenje',
        problem: 'Problem',
        fixing: 'Popravka',
        changeOrder: 'Promena naloga',
        required: 'Potrebno',
        icon: 'Ikona',
        color: 'Boja',
        subCategories: 'Podkategorije',
        barCode: 'Bar kod',
        subLocations: 'Podlokacije',
        categories: 'Kategorije',
        image: 'Slika',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'E-mail',
        phone: 'Broj telefona',
        function: 'Funkcija',
        department: 'Odeljenje',
        accountStatus: 'Status naloga',
        shift: 'Smena',
        licenseNumber: 'Broj licence',
        issuedDate: 'Datum izdavanja',
        expiresDate: 'Datum isteka',
        entries: 'Unosi',
        entryNumber: 'Broj unosa',
        buyPrice: 'Cena kupovine',
        currentLocationQuantity: 'Količina na trenutnoj lokaciji',
        group: 'Grupa',
        string: 'Tekst',
        integer: 'Ceo broj',
        toolsGroup: 'Grupa alata',
        manufacturer: 'Proizvođač',
        shortName: 'Kratko ime',
        locationName: 'Ime lokacije',
        subLocationsQuantity: 'Količina na podlokacijama',
        isWorkingOnIssue: 'Radi na problemu',
        openIssues: 'Otvoreni problemi',
        notificationDate: 'Datum obaveštenja',
        titleAndDescription: 'Naslov i opis',
        read: 'Pročitano',
        created_at: 'Kreirano',
        received_at: 'Primljeno',
        started_at: 'Uzet',
        arrived_at: 'Stigao',
        finished_at: 'Završen',
        country: 'Zemlja',
        city: 'Grad',
        progress: 'Napredak',
    },
    searchConfig: {
        id: 'ID',
        name: 'Ime...',
        shortName: 'Kratko ime...',
        country: 'Država...',
        email: 'Email...',
        group: 'Grupa...',
        planned: 'Planirano',
        category: 'Kategorija...',
        object: 'Objekat...',
        criticality: 'Kritičnost',
        fp: 'FP',
        type: 'Tip...',
        designation: 'Naziv...',
        symbol: 'Simbol...',
        serialNumber: 'Serijski broj...',
        registryNumber: 'Registarski broj...',
        udtNumber: 'UDT broj...',
        manufacturedYear: 'Godina proizvodnje...',
        manufacturerSymbol: 'Simbol proizvođača...',
        priority: 'Prioritet...',
        quantity: 'Količina...',
        buyPrice: 'Cena kupovine...',
        kind: 'Vrsta...',
        toolsGroup: 'Grupa alata...',
        function: 'Funkcija...',
        department: 'Odeljenje...',
        status: 'Status...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefon...',
        barCode: 'Bar kod',
        color: 'Boja...',
        icon: 'Ikona...',
        machine: 'Mašina...',
        tool: 'Alat...',
        urgentAndOutdated: 'Hitno i zastarelo',
        urgent: 'Hitno',
        expired: 'Isteklo',
        manufacturer: 'Proizvođač',
    },
    errors: {
        error: 'Desila se greška',
        wrongEmail: 'Neispravna e-mail adresa',
        wrongPasswordLength: 'Lozinka mora imati najmanje 8 karaktera.',
        wrongCodeLength: 'Kod mora imati najmanje 5 karaktera.',
        passwordsNotMatch: 'Lozinke se ne poklapaju',
        codesNotMatch: 'Kodovi se ne poklapaju',
        codeAlreadyInUse: 'Kod je već u upotrebi',
        expiresDateLowerThanIssued:
            'Datum isteka ne može biti manji od datuma izdavanja.',
        cannotMoveToTheSameLocation: 'Ne može se premestiti na isto mesto.',
        locationRequired: 'Lokacija je obavezna.',
        putQuantity: 'Unesite količinu za odvajanje.',
        valueGreaterThanQuantity: 'Vrednost je veća od ukupne količine.',
        wholeCannotBeDistinguished: 'Ceo ne može biti razdvojen.',
        yearMustBeGreaterThan: 'Godina mora biti veća od ',
        passwordConfirmationNotMatch: 'Lozinke se ne poklapaju',
        mustBeInteger: 'Vrednost mora biti celi broj',
        valueTooLong: 'Vrednost je prekomerna',
        wrongPhoneNumber: 'Pogrešan broj telefona',
        phoneNumberAlreadyTaken: 'Broj telefona je već zauzet',
        emailAlreadyTaken: 'E-mail adresa je već zauzeta',
        notFound: 'Nije pronađeno',
        sessionExpired: 'Sesija je istekla',
        tenantNotFound:
            'Navedena konfiguracija ne postoji. Proverite adresu sajta i pokušajte ponovo.',
        selectEquipmentTypeToConfigureParameters:
            'Odaberite tip opreme za konfigurisanje parametara.',
        noParametersToConfigure:
            'Odabrani tip opreme nema parametre za konfigurisanje.',
        terminalAlreadyRegistered: 'Terminal je već registrovan.',
        invalidPin: 'Neispravan PIN',
        eventCollision:
            'Vreme događaja koje želite da dodate se preklapa sa vremenom drugog događaja.',
        mustStartWithSlash: 'Mora početi sa /',
        mustBeBetween: 'Vrednost mora biti između:',
        minLength: 'Minimalna dužina: ',
        maxLength: 'Maksimalna dužina: ',
        invalidInputForCodeType: 'Neispravan unos za odabrani tip koda',
        invalidCodeOrNoPermission:
            'Kod nije validan ili nemate dovoljno dozvola za izvršavanje ovog radnje.',
        endDateLowerThanStart:
            'Krajnji datum ne može biti manji od početnog datuma',
        iconAlreadyTaken: 'Ikona je već zauzeta',
        notEnoughQuantityInStorage: 'Nedovoljna količina u skladištu.',
        valueTooLow: 'Vrednost je preniska',
        valueTooHigh: 'Vrednost je previsoka',
        maxAvailableQuantity: 'Maksimalna količina',
        someFilesRejectedDueToSize:
            'Neke datoteke su odbijene zbog veličine. Maksimalna veličina jedne datoteke:',
        cameraDeviceNotFound: 'Kamera nije otkrivena',
        cameraPermissionDenied:
            'Pristup kameri uređaja je blokiran u podešavanjima sajta, resetujte podešavanja sajta i dozvolite korišćenje kamere.',
        passwordResetLinkExpired: 'Veza za resetovanje lozinke je istekla',
        noInternetConnection: 'Nema internet veze',
        minimum: 'Minimalna vrednost: ',
        mustBeGreaterThan: 'Vrednost mora biti veća od ',
        noEventTypesDefined: 'Nema definisanih tipova događaja',
        regexPatternDelimiterError:
            'Razdjelnik mora biti izostavljen znakom \\, npr.: \\/',
        emailNotMatchPatternDefiniedInTenant:
            'E-mail adresa ne odgovara šablonu definisanom u konfiguraciji',
        partMustHaveEntriesToCorrectQuantity:
            'Deo mora imati unose za ispravku količine.',
        fileTooBigToOpenWillBeDownloaded:
            'Datoteka je prevelika za otvaranje, datoteka će biti preuzeta na vaš uređaj.',
        entriesNotSavedDueToCollision:
            'Unosi nisu dodati. Događaji već postoje u izabrano vreme.',
        someEntriesWereRejected:
            'Neki unosi nisu dodati jer su u suprotnosti sa drugim događajima.',
        toolAlreadyInCart: 'Ovaj alat je već u vašoj korpi',
        toolAlreadyTaken: 'Ovaj alat je već objavljen',
        toolIsNotTaken: 'Ovaj alat nije objavljen',
        documentNotEditable: 'Ovaj dokument se ne može uređivati',
        notPermissionsToEditDocument:
            'Nemate dozvolu za uređivanje ovog dokumenta',
        cannotLoadDocumentNoPath:
            'Nije moguće učitati dokument – nevažeća adresa',
        locationNameNotMatchPatternDefiniedInTenant:
            'Naziv se ne poklapa sa pravilom definisanim u podešavanjima',
        noFloorLayoutProvided: 'Sprat nema definisanu mapu',
        maximum: 'Maksimalna vrednost',
        allLanguagesRequired: 'Popunite vrednost na svim jezicima',
        noItemsAvailable: 'Nema dostupnih stavki',
        noFlagsConfigured: 'Nema definisanih zastavica',
        noSkillsDefined: 'Nema definisane veštine',
        someoneIsWorkingOnIssue:
            'Nisu svi zaposleni završili posao na ovom izveštaju. Da li ste sigurni da želite da ga okončate?',
        fillAllRequiredParameters: 'Popunite sve potrebne parametre.',
        issueLimitError:
            'Dostignuto je ograničenje broja izdanja u izabranoj kategoriji za: ',
        issueLimitError2: 'i funkcija: ',
        duplicateError: 'Ova vrednost već postoji',
        versionErrorMessage:
            'Vaše nedavne promene nisu sačuvane jer je neko drugi uneo izmene u isto vreme. Osvežite stranicu i pokušajte ponovo.',
        firstLoginTrustedDeviceError:
            'Prvo prijavljivanje na novom uređaju zahteva unos vaše e-mail adrese i lozinke.',
        tagNotFound: 'Kartica/oznaka nije prepoznata',
        noChecklistsAssignedToControl:
            'Izabranoj kontroli nema dodeljenu kontrolnu listu',
        lockerNotConnected: 'Brava nije povezana',
        lockerNotAvailable: 'Brava nije dostupna',
        noChecklistItemsError: 'Kontrolna lista nije konfigurisana',
    },
    navDrawer: {
        dashboard: 'Kontrolna tabla',
        issues: 'Problemi',
        timetable: 'Raspored',
        machines: 'Mašine',
        tools: 'Alati',
        parts: 'Delovi',
        storage: 'Skladište',
        staff: 'Osoblje',
        configuration: 'Konfiguracija',
        notes: 'Bilješke',
        notifications: 'Obaveštenja',
        profile: 'Profil',
        supervision: 'Nadzor',
    },
    barcodeScanner: {
        barCode: 'Bar kod',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Kategorija...',
        selectCategory: 'Izaberite kategoriju',
        noSubcategories: 'Nema podkategorija',
    },
    companies: {
        addCompany: 'Dodajte kompaniju',
        editCompany: 'Izmjeni kompaniju',
        fullName: 'Puno ime',
        shortName: 'Kratko ime',
        group: 'Grupa',
        country: 'Zemlja',
        city: 'Grad',
        street: 'Ulica',
        postCode: 'Poštanski broj',
        phone: 'Telefon',
        email: 'E-mail',
        website: 'Veb stranica',
        NIP: 'NIP',
        REGON: 'Registar privrednih subjekata',
        active: 'Aktivan',
        nameRequired: 'Ime je obavezno',
        shortNameRequired: 'Ime je obavezno',
    },
    issues: {
        tookAt: 'Uzeto u',
        changeHistory: 'Istorija promene',
        load: 'Učitaj',
        date: 'Datum',
        createdBy: 'Kreirao',
        action: 'Akcija',
        data: 'Podaci',
        created: 'Kreirano',
        updated: 'Ažurirano',
        deleted: 'Uklonjeno',
        restored: 'Vraćeno',
        issues: 'Problemi',
        issue: 'Problem',
        by: 'od',
        name: 'Ime',
        applicantsDescription: 'Opis zahteva',
        accidentDescription: 'Opis nesreće',
        jobDescription: 'Opis posla',
        jobSummary: 'Sažetak posla',
        category: 'Kategorija',
        status: 'Status',
        noFlow: '[Bez toka]',
        equipment: 'Oprema',
        criticality: 'Kritičnost',
        hour: 'Sat',
        formalConfirmation: 'Formalna potvrda',
        formalConfirmationShortcut: 'FP',
        formalConfirmationRequired: 'Potrebna FP',
        parameter: 'Parametar',
        value: 'Vrednost',
        addIssue: 'Dodaj problem',
        expectedCompletionDate: 'Očekivani datum završetka',
        issueDescription: 'Opis problema',
        partsUsage: 'Upotreba delova',
        assignedEmployees: 'Dodeljeni zaposleni',
        requiredHelp: 'Potrebna pomoć',
        returnParts: 'Vrati deo',
        confirmUnassignEmployeeWhoTakenIssue:
            'Ovaj zaposleni je preuzeo izabrani problem. Da li želite da ga uklonite?',
        responsibleUser: 'Odgovorni korisnik',
        responsibleRules: 'Odgovorni korisnici - pravila',
    },
    machines: {
        machines: 'Mašine',
        xIssuesNotPlanned: ' (nije planirano)',
        noIssues: 'Nema problema',
    },
    maintenance: {
        maintenance: 'Održavanje',
    },
    notes: {
        notes: 'Beleške',
        note: 'Beleška',
        title: 'Naslov',
        archived: 'Arhivirano',
    },
    parts: {
        parts: 'Delovi',
        warehouseOutgoings: 'Izlaz robe iz magacina',
        fittingEquipmentTypes: 'Tipovi opreme za ugradnju',
        goToEquipmentType: 'Idi na tip opreme',
        selectPart: 'Izaberite deo',
        usageReason: 'Razlog',
        usageOtherReason: 'Drugo',
        replacements: 'Zamene',
        partEntry: 'Unos dela',
        goToPart: 'Idi na deo',
        fittingMachines: 'Mašine za podudaranje',
    },
    costCenter: {
        costCenter: 'Troškovni centar',
    },
    equipmentTypes: {
        equipment: 'Oprema',
        newEquipmentType: 'Novi tip opreme',
        fittingParts: 'Delovi za ugradnju',
        goToParts: 'Idi na deo',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Definicije mašina i alata',
    },
    flows: {
        flow: 'Tok',
        states: 'Stanja',
        transitions: 'Prelazi',
        state: 'Stanje',
        default: 'Podrazumevano',
        warning: 'Upozorenje',
        problem: 'Problem',
        fixing: 'Popravka',
        finished: 'Gotov',
    },
    parameters: {
        categoryParameter: 'Parametar kategorije',
        equipmentTypeParameter: 'Parametar tipa opreme',
    },
    staff: {
        staff: 'Osoblje',
        editUserAccess: 'Uredi pristup korisnika',
        permissionsUpdated: 'Dozvole ažurirane',
        passwordUpdated: 'Lozinka ažurirana',
        codeUpdated: 'Kod ažuriran',
        changePasswordAndCode: 'Promena lozinke i koda',
        goToLicenses: 'Idi na licence',
        editAccess: 'Uredi pristup',
        editUser: 'Uredi korisnika',
        addUser: 'Dodaj novog korisnika',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Status naloga',
        phoneNumber: 'Broj telefona',
        department: 'Odeljenje',
        passwordChange: 'Promena lozinke',
        codeChange: 'Promena koda',
        newPassword: 'Nova lozinka',
        confirmNewPassword: 'Potvrdi novu lozinku',
        changePassword: 'Promeni lozinku',
        newCode: 'Novi kod',
        confirmNewCode: 'Potvrdi novi kod',
        changeCode: 'Promeni kod',
        addEntry: 'Dodaj unos',
        editEntry: 'Uredi unos',
        editLicense: 'Uredi licencu',
        addLicense: 'Dodaj licencu',
        licenseNumber: 'Broj licence',
        prefferedLocale: 'Preferirani jezik',
        oldPassword: 'Stara lozinka',
        newPasswordConfirmation: 'Potvrdi novu lozinku',
        reading: 'Prikazivanje',
        creating: 'Kreiranje',
        updating: 'Ažuriranje',
        deleting: 'Brisanje',
        importScheduleFile: 'Uvezite raspored iz datoteke',
        importSchedule: {
            errors: {
                user_not_found: 'Korisnik nije pronađen [{user}]',
                user_found_many: '{count} korisnika pronađeno [{user}]',
                event_collision: 'Sukob događaja',
                hour_cell_parse: 'Greška pri raščlanjivanju ćelije',
            },
        },
        oldCode: 'Stari kod',
        newCodeConfirmation: 'Potvrda novog koda',
        setAccessBasedOnProfile: 'Odobrite pristup na osnovu profila',
        selectAccessMergeType: 'Izaberite kako da kombinujete dozvole',
        noAccessesInProfileMessage:
            'Izabrani profil nema dozvole. Da li ipak želite da prepišete?',
    },
    breadCrumb: {
        configuration: 'Konfiguracija',
        locations: 'Lokacije',
        home: 'Početna',
        machines: 'Mašine',
        tools: 'Alati',
        issues: 'Problemi',
        notes: 'Beleške',
        maintenance: 'Održavanje',
        parts: 'Delovi',
        warehouse: 'Magacin',
        dictionary: 'Rečnik',
        categories: 'Kategorije',
        parameters: 'Parametri',
        costCenter: 'Troškovni centar',
        flows: 'Tokovi',
        states: 'Stanja',
        transitions: 'Prelazi',
        shiftSchemas: 'Šeme smena',
        shifts: 'Smena',
        definitionsOfMachinesAndToolsTypes: 'Definicije tipova mašina i alata',
        add: 'Dodaj',
        edit: 'Uredi',
        staff: 'Osoblje',
        licenses: 'Licence',
        entries: 'Unosi',
        companiesDatabase: 'Baza kompanija',
        companyManagement: 'Upravljanje kompanijom',
        companyData: 'Podaci o kompaniji',
        supportedLanguages: 'Podržani jezici',
        en: 'Engleski',
        pl: 'Poljski',
        es: 'Španski',
        de: 'Nemački',
        defaultLanguage: 'Podrazumevani jezik',
        notifications: 'Obaveštenja',
        notificationsManagement: 'Upravljanje obaveštenjima',
        myProfile: 'Moj profil',
    },
    attributeTypes: {
        text: 'Tekst',
        note: 'Beleška',
        integer: 'Ceo broj',
        decimal: 'Decimalni broj',
        date: 'Datum',
        time: 'Vreme',
        dateTime: 'Datum i vreme',
        color: 'Boja',
        icon: 'Ikona',
        boolean: 'Da/Ne',
    },
    costCalculator: {
        costCalculator: 'Kalkulator troškova',
        waitTime: 'Vreme čekanja',
        serviceTime: 'Vreme usluge',
        suspendTime: 'Vreme pauze',
        totalTime: 'Ukupno vreme',
        estimatedCost: 'Procenjeni troškovi',
        calculate: 'Izračunaj',
        withoutParts: 'Bez delova',
        timeOfReportingIssue: 'Vreme prijave problema',
        timeOfServiceStart: 'Vreme početka usluge',
        timeOfReportingEnd: 'Vreme završetka usluge',
        days: 'Dani',
        hours: 'Sati',
        minutes: 'Minuti',
        enterNewTime: 'Unesite novo vreme',
        fromIssueReportToServiceStart:
            'Vreme od prijave problema do početka usluge',
        fromServiceStartToServiceEnd:
            'Vreme od početka usluge do završetka usluge',
        workTime: 'Radno vreme',
        includeAwaitingTime: 'Uključi vreme čekanja',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Moji problemi',
                assignedToMe: 'Dodeljeno meni',
                assignedToGroup: 'Dodeljeno mojoj grupi',
                tookByMe: 'Preuzeto od mene',
                takeIssueBtn: 'Preuzmi',
                arriveIssueBtn: 'Stigao sam',
                finishIssueBtn: 'Završi',
                history: 'Istorija',
                myResponsible: 'Ja sam odgovoran za',
            },
        },
    },
    synchronization: {
        enabled: 'Omogućeno',
        hasHeaders: 'Ima zaglavlja',
        leaveFile: 'Ostavi fajl',
        host: 'Host',
        port: 'Port',
        protocol: 'Protokol',
        username: 'Korisničko ime',
        password: 'Lozinka',
        root: 'Koren',
        encoding: 'Enkodiranje',
        separator: 'Separator',
        externalSystemId: 'ID eksternog sistema',
        cronExpression: 'Cron izraz',
        appendFullStock: 'Dodaj kompletnu zalihu',
        includeHeaders: 'Uključi zaglavlja',
        withTrashed: 'Sa uklonjenim podacima',
        filePattern: 'Obrazac fajla',
    },
    processes: {
        created_at: 'Datum kreiranja',
        started_at: 'Datum početka',
        updated_at: 'Datum ažuriranja',
        finished_at: 'Datum završetka',
        attempts: 'Pokušaji',
        queue: 'Red',
        job_id: 'ID zadatka',
        job_uuid: 'UUID zadatka',
        progress_max: 'Maksimalan napredak',
        progress_now: 'Trenutni napredak',
        outputMessage: 'Izlazna poruka',
        status: {
            queued: 'U redu',
            executing: 'Izvršavanje',
            finished: 'Završeno',
            failed: 'Neuspešno',
            retrying: 'Ponovo pokušaj',
            undefined: 'Nedefinisano',
        },
    },
    weekDays: {
        mo: 'Ponedeljak',
        tu: 'Utorak',
        we: 'Sreda',
        th: 'Četvrtak',
        fr: 'Petak',
        sa: 'Subota',
        su: 'Nedelja',
    },
    reports: {
        reports: 'Izveštaji',
        dateFrom: 'Datum od',
        dateTo: 'Datum do',
        types: {
            operation_sheet: 'Operativni list',
            issue_summary: 'Rezime problema',
            grouped_summary: 'Rezime izveštaj',
            storage_operations: 'Skladišne operacije',
            part_quantity_export: 'Količina delova',
        },
        reportFor: 'Izveštaj za',
        includeQuantityLeft0: 'Uključite delove sa nultom količinom',
    },
    logs: {
        issues: {
            escalation: 'Eskalacija ({minutes} min) - obaveštenje poslato',
        },
        issueEmployee: {
            assignedAt: 'Zaposleni dodeljen:',
            receivedAt: 'Zaposleni primio:',
            tookAt: 'Zaposleni preuzeo:',
            finishedAt: 'Zaposleni završio:',
            deletedAt: 'Zaposleni uklonjen iz prijave',
        },
    },
    units: {
        no: 'Komad',
        st: 'комплет',
    },
    rrule: {
        frequency: 'Frekvencija',
        dtstart: 'Datum početka',
        tzid: 'Vremenska zona',
        until: 'Sve dok',
        count: 'grof',
        interval: 'interval',
        wkst: 'Početak dana',
        byweekday: 'do radnog dana',
        bymonth: 'Po mesecu',
        yearly: 'godišnje',
        monthly: 'mesečno',
        weekly: 'nedeljno',
        daily: 'dnevno',
        hourly: 'Po satu',
        minutely: 'minut',
        secondly: 'Drugo',
        infinitePeriodicityMessage:
            'Periodičnost je beskonačna, zbog performansi se prikazuje samo 500 redova',
    },
    months: {
        jan: 'januara',
        feb: 'februar',
        mar: 'mart',
        apr: 'April',
        may: 'Može',
        jun: 'jun',
        jul: 'Jul',
        aug: 'avgust',
        sep: 'Septembar',
        oct: 'oktobar',
        nov: 'novembar',
        dec: 'decembar',
    },
    charts: {
        charts: 'grafikon',
        count: 'Broj izdanja',
        total: 'Ukupno vreme problema (od izveštaja do kraja)',
        serw: 'Ukupno vreme popravke (Ttotal - Twait)',
        mttr1: 'Prosečno vreme od izveštaja do kraja',
        mttr2: 'Prosečno vreme od snimanja do kraja',
        mtbf: 'Prosečno vreme rada između problema',
        mttf: 'Srednje vreme do neuspeha',
    },
    accessMergeValues: {
        sum: 'Sum',
        product: 'Proizvod',
        overwrite: 'Prepisati',
    },
    tpm: {
        history: 'Istorija',
        standardObstacle: 'Standardna prepreka',
        customObstacle: 'Prilagođena prepreka',
        bhp: 'Bezbednost i zdravlje na radu',
        returnToMainPage: 'Povratak na glavnu stranicu',
        bhpMessage:
            'Ako primetite rizike po bezbednost, odmah obavestite nadređenog i koristite prijavni obrazac koji se nalazi ispod oglasne table.',
        ok: 'U redu',
        send: 'Pošalji',
        description: 'Opis',
        title: 'Naslov',
        realization: 'Realizacija',
        answer: 'Odgovor',
        pendingSurveys: 'Nerešene ankete',
        surveys: 'Ankete',
        systemSurvey: 'Sistematska anketa',
        addPage: 'Dodaj stranicu',
        createSurvey: 'Kreiraj anketu',
        addSection: 'Dodaj sekciju',
        addQuestion: 'Dodaj pitanje',
        questionContent: 'Sadržaj pitanja',
        answerOption: 'Opcija odgovora',
        addQuestionAnswer: 'Dodaj opciju odgovora',
        surveyName: 'Naziv ankete',
        sectionName: 'Naziv sekcije',
        noSurveyAnswers: 'Nema odgovora',
        removeSection: 'Ukloni sekciju',
        published: 'Objavljeno',
        unpublished: 'Nije objavljeno',
        pendingPublication: 'Promene čekaju objavu',
        removeQuestion: 'Ukloni pitanje',
        removeAnswer: 'Ukloni opciju odgovora',
        publish: 'Objavi',
        unpublish: 'Povuci objavu',
        previewResults: 'Pregledaj rezultate',
        supervisior: 'Nadređeni',
        surveyResults: 'Rezultati ankete',
        surveysEvents: 'Konfiguracija događaja - ankete',
        operatedBy: 'Pokreće',
        confirmReadInformations: 'Potvrđujem da sam pročitao informacije',
        noticeContent: 'Sadržaj obaveštenja',
        notice: 'Obaveštenje',
        surveyEventName: 'Naziv događaja',
        survey: 'Anketa',
        newIssue: 'Novi problem',
        surveyEventConfigurationAlreadyExists:
            'Konfiguracija događaja već postoji',
        lastComment: 'Poslednji komentar odgovorne osobe',
        surveyNotConfigured: 'Anketa nije konfigurisana',
        fillSurvey: 'Popuni anketu',
        singleSurveyEntries: 'pojedinačni rezultati.',
        groupedSurveyEntries: 'Grupisani rezultati.',
        publicationId: 'ID publikacije.',
        publicationDate: 'Datum izdavanja.',
        versionId: 'ID verzije.',
        answersCount: 'Broj odgovora.',
        answers: 'Odgovori',
        withoutSupervisor: 'Nema nadzornika',
        defaultSupervisor: 'Podrazumevani nadzornik',
        flowStateFlags: 'Statusne zastavice',
        qrActionsSettings: 'Podešavanja akcije QR koda',
        loginRequired: 'Zahteva prijavu',
        questionContext: 'Kontekst pitanja',
        currentSurveyVersionPreview: 'Pregled trenutne verzije ankete',
        surveyDescription: 'Opis ankete',
        sectionDescription: 'Opis sekcije',
        instructions: 'Uputstva',
        instruction: 'uputstvo',
        instructionRevisions: 'Revizije',
        instructionRevision: 'revizija',
        checklists: 'Kontrolne liste',
        checklist: 'Kontrolna lista',
        checklistItem: 'Lista stvari',
        manageChecklistFields: 'Upravljajte stavkama liste',
        checklistItemDisplayOptions: 'Prikazane stavke',
        revisionAutoRejectedInfo: '[Sistem] Odbijeno - kreirana nova revizija',
    },
    checklists: {
        itemBasic: 'Osnovni element',
        itemSeparator: 'Separator',
        itemSection: 'Sekcija',
        publish: 'Objavite',
        previewCurrentVersion: 'Pregled trenutne verzije',
    },
};
